function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.09408 1.09408C1.38697 0.801188 1.86185 0.801188 2.15474 1.09408L5 3.93934L7.84526 1.09408C8.13815 0.801188 8.61303 0.801188 8.90592 1.09408C9.19881 1.38697 9.19881 1.86185 8.90592 2.15474L6.06066 5L8.90592 7.84526C9.19881 8.13815 9.19881 8.61303 8.90592 8.90592C8.61303 9.19881 8.13815 9.19881 7.84526 8.90592L5 6.06066L2.15474 8.90592C1.86185 9.19881 1.38697 9.19881 1.09408 8.90592C0.801188 8.61303 0.801188 8.13815 1.09408 7.84526L3.93934 5L1.09408 2.15474C0.801188 1.86185 0.801188 1.38697 1.09408 1.09408Z",
  fill: "#1D263B"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.9e406559.svg";
export { ForwardRef as ReactComponent };